import { Chip } from '@mui/material';

export const BenchmarkBadge = ({
  benchmarkGridName,
}: {
  benchmarkGridName: string;
}) => {
  return (
    <Chip
      sx={{
        height: 18,
        '.MuiChip-label': {
          py: 1,
          px: 0.5,
          fontSize: 11,
        },
      }}
      label={benchmarkGridName}
      className={
        'bg-informational-25 text-informational-700 text-[10px] ml-auto mr-1'
      }
    />
  );
};
